import { useBoolean } from '@aibees/shared/hooks';
import { createContext, useContext, useMemo } from 'react';
import {
  SearchFilterContextData as ContextData,
  SearchFilterContextProps as ContextProps,
} from './types';

const context = createContext<ContextData>({} as ContextData);

export const { Provider } = context;

export const useSearchFilterContext = () => useContext(context);

export const SearchFilterProvider = ({ children }: ContextProps) => {
  // these are the bulk filter field values, if they change we need to change these also
  // todo: maziar: we need to create a constant config for filter fields
  const bulk_company_social = useBoolean(false);
  const bulk_company_domain = useBoolean(false);
  const bulk_company_name = useBoolean(false);
  const bulk_person_linkedin_url = useBoolean(false);

  const bulkDialogStates = useMemo(
    () => ({
      bulk_company_social,
      bulk_company_domain,
      bulk_company_name,
      bulk_person_linkedin_url,
    }),
    [
      bulk_company_social,
      bulk_company_domain,
      bulk_company_name,
      bulk_person_linkedin_url,
    ]
  );

  return <Provider value={{ bulkDialogStates }}> {children}</Provider>;
};
